import { useEffect } from "react";
import { imgUrl } from "@/lib/api";

const abs = (src) => {
  const u = imgUrl(src);
  return u?.startsWith("http") ? u : `https://pettokshop.net${u}`;
};

// ItemList structured data for the Kiddee collection, built from real catalog data.
export const CollectionJsonLd = ({ products }) => {
  useEffect(() => {
    if (!products.length) return;
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "Kiddee Approved Dog Toys",
      itemListElement: products.map((p, i) => ({
        "@type": "ListItem",
        position: i + 1,
        url: `https://pettokshop.net/product/${p.slug}`,
        name: p.name,
        image: abs(p.image),
      })),
    });
    document.head.appendChild(el);
    return () => el.remove();
  }, [products]);
  return null;
};
